export default "__VITE_ASSET__1dd1cefc__"